import { View } from "@frui.ts/views/dist";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import Tabs from "views/common/tabs";
import SearchViewModel from "viewModels/callCenter/search/searchViewModel";

export const toolbarContext = "toolbar";

export const SearchResultsView: ViewComponent<SearchViewModel> = observer(({ vm }) => {
  if (vm.isFilterEmpty) {
    return (
      <div className="justify-content-center align-items-center py-10 border rounded text-center">
        <span className="font-weight-bold text-secondary h4">{vm.translate("toStartFilter")}</span>
      </div>
    );
  }

  return (
    <div style={{ overflowX: "auto", minHeight: "50vh" }}>
      <Tabs
        vm={vm}
        itemsCount={vm.itemsCount}
        totalCountMessages={vm.totalCountMessages}
        totalCountExemptions={vm.totalCountExemptions}
        totalCountCharges={vm.totalCountCharges}
        totalCountVehicleRegister={vm.totalCountVehicleRegister}
        displayVehicleRegisterWarning={vm.displayVehicleRegisterWarning}
        tooltipText={
          vm.displayVehicleRegisterWarning && vm.vehicleSearchStatus
            ? vm.translateVehicleSearchStatus(vm.vehicleSearchStatus)
            : undefined
        }
        variant="white">
        <Observer>{() => <View vm={vm.activeChild} context={toolbarContext} />}</Observer>
      </Tabs>
    </div>
  );
});

registerView(SearchResultsView, SearchViewModel);
